import { render, staticRenderFns } from "./AppRouterLink.vue?vue&type=template&id=2f79d64e&"
import script from "./AppRouterLink.vue?vue&type=script&lang=js&"
export * from "./AppRouterLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports